import { route as brandOrderReviewRoute } from "@faire/web-api--source/routes/www/my-reviews/brand-order/brandOrderToken";
import { route as reviewableProductsRoute } from "@faire/web-api--source/routes/www/my-reviews/brand-order/brandOrderToken/products";
import { route as productReviewRoute } from "@faire/web-api--source/routes/www/my-reviews/brand-order/brandOrderToken/products/productToken";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";

export const isHighPriorityReviewsPath = (pathname: string) => {
  return (
    pathMatchesRoute(pathname, brandOrderReviewRoute) ||
    pathMatchesRoute(pathname, reviewableProductsRoute) ||
    pathMatchesRoute(pathname, productReviewRoute)
  );
};
